import { Controller } from "@hotwired/stimulus"

// When a <details> element is opened, triggers the lazy Turbo Frame inside it
// to load the search highlight from the server.
// Usage:
//   <details data-controller="lazy-highlight" data-action="toggle->lazy-highlight#load">
//     <turbo-frame id="highlight-123" data-lazy-highlight-target="frame" data-src="/globalsearch_highlight?...">
//     </turbo-frame>
//   </details>
export default class extends Controller {
  static targets = ["frame"]

  load(event) {
    if (!event.target.open) return  // only trigger on open, not on close
    if (!this.hasFrameTarget) return

    const frame = this.frameTarget
    // Only load once — if src is already set (or already loaded), skip
    if (frame.src || frame.getAttribute("src")) return

    const lazySrc = frame.dataset.src
    if (lazySrc) frame.src = lazySrc
  }
}
